export interface SceneDefinition {
  id: string;
  nameKey: string;
  defaultTimeOfDay: number; // 0..5
  defaultWeather: 'sunny' | 'rain' | 'snow';
  supportedWeather: ('sunny' | 'rain' | 'snow')[];
  suggestedMusicMoods: string[];
}

export const SCENE_DEFINITIONS: SceneDefinition[] = [
  {
    id: 'yulong',
    nameKey: 'scene_yulong',
    defaultTimeOfDay: 1, // morning
    defaultWeather: 'sunny',
    supportedWeather: ['sunny', 'rain', 'snow'],
    suggestedMusicMoods: ['airy', 'gentle', 'cheerful', 'mountain'],
  },
  {
    id: 'lijiang',
    nameKey: 'scene_lijiang',
    defaultTimeOfDay: 5, // night / dusk
    defaultWeather: 'sunny',
    supportedWeather: ['sunny', 'rain', 'snow'],
    suggestedMusicMoods: ['warm', 'folk', 'guzheng', 'night'],
  },
  {
    id: 'erhai',
    nameKey: 'scene_erhai',
    defaultTimeOfDay: 0, // dawn / sunrise
    defaultWeather: 'sunny',
    supportedWeather: ['sunny', 'rain'], // snow only high Cangshan
    suggestedMusicMoods: ['peaceful', 'water', 'flute', 'dreamy'],
  },
];
